export function linkFormatter(link: string) {
  if (link && (!link.startsWith('http://') || !link.startsWith('https://'))) {
    return 'https://' + link;
  } else {
    return link;
  }
}
